import {ProductCard} from '~/components';
import {getImageLoadingPriority} from '~/lib/const';
import * as _ from 'lodash';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

function CollectionCard(collection: any) {
  const {collection: data} = collection;

  return (
    <div className="container">
      <AccordionItem uuid={_.get(data, 'id', '')}>
        <AccordionItemHeading>
          <AccordionItemButton>
            <span>{_.get(data, 'title', '')}</span>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <div className="row">
            {_.get(data, 'products.nodes', []).map((product: any, i: any) => (
              <ProductCard
                key={`${_.get(product, 'id')}-product- ${i}`}
                product={product}
                loading={getImageLoadingPriority(i)}
                quickAdd
              />
            ))}
          </div>
        </AccordionItemPanel>
      </AccordionItem>
    </div>
  );
}
const ProductsList = ({collectionProducts}: {collectionProducts: any[]}) => {
  const preExpanded = _.get(collectionProducts, '[0].collection.id');
  return (
    <>
      <div className="shop-area ptb-80">
        <div className="container">
          <div className="ro">
            <div className="faq-accordio">
              <Accordion
                preExpanded={[preExpanded || '']}
                allowMultipleExpanded
                allowZeroExpanded
              >
                {_.map(
                  _.uniqBy(collectionProducts, (e) =>
                    _.get(e, 'collection.id'),
                  ),
                  (item, i) => {
                    const {collection} = item;

                    return (
                      <CollectionCard
                        key={`${collection?.id}-${i}`}
                        collection={collection}
                      />
                    );
                  },
                )}
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductsList;
